import { useEffect, useState } from 'react';
import { useViewStore } from '../../stores/viewStore';
import { useOffice } from './OfficeContext';
import './office.css';

const SAMPLE_MS = 500;

/**
 * Bildrate und Zeichenlast der Ego-Ansicht. Nur mit `?perf` in der Adresse
 * oder `etown.perf=1` im localStorage — im Alltag soll nichts im Bild stehen.
 */
export function isPerfEnabled(): boolean {
  try {
    return new URLSearchParams(window.location.search).has('perf') || window.localStorage.getItem('etown.perf') === '1';
  } catch {
    return false;
  }
}

interface PerfStats {
  fps: number;
  /** null, solange die Ansicht keine Zeichenstatistik fuehrt (Draufsicht). */
  draw: { calls: number; triangles: number } | null;
}

export function PerfOverlay() {
  const { runtime } = useOffice();
  const mode = useViewStore((s) => s.mode);
  const [stats, setStats] = useState<PerfStats | null>(null);

  useEffect(() => {
    // Die Bildrate gilt in beiden Ansichten — genau der Vergleich ist der
    // Sinn der Anzeige. Die Zeichenlast liefert nur die Ego-Ansicht; Pixi
    // fuehrt keine vergleichbare Statistik.
    let frames = 0;
    let raf = 0;
    const count = (): void => {
      frames += 1;
      raf = requestAnimationFrame(count);
    };
    raf = requestAnimationFrame(count);

    const timer = window.setInterval(() => {
      setStats({ fps: Math.round((frames * 1000) / SAMPLE_MS), draw: runtime.renderStats() });
      frames = 0;
    }, SAMPLE_MS);

    return () => {
      cancelAnimationFrame(raf);
      window.clearInterval(timer);
    };
  }, [runtime, mode]);

  if (!stats) return null;
  return (
    <div className="office__perf" role="status">
      <span>{stats.fps} fps</span>
      {stats.draw && (
        <>
          <span>{stats.draw.calls} Draw-Calls</span>
          <span>{(stats.draw.triangles / 1000).toFixed(1)}k Dreiecke</span>
        </>
      )}
    </div>
  );
}
